module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/logo-下载横幅-图标.46fcd.png";